module.exports = __webpack_public_path__ + "static/img/page01.9051dfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page01.jpg
// module id = l1aE
// module chunks = 0